/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateCategoryCommand } from '../../models/update-category-command';
import { UpdateCategoryCommandResult } from '../../models/update-category-command-result';

export interface ApiNurseryManagerCategoryUpdateCategoryPatch$Params {
      body?: UpdateCategoryCommand
}

export function apiNurseryManagerCategoryUpdateCategoryPatch(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerCategoryUpdateCategoryPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateCategoryCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerCategoryUpdateCategoryPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateCategoryCommandResult>;
    })
  );
}

apiNurseryManagerCategoryUpdateCategoryPatch.PATH = '/api/NurseryManager/Category/UpdateCategory';
